import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  list: {},
  scrollIndex: 0,
};

export const productDetail = createSlice({
  name: 'productDetail',
  initialState,
  reducers: {
    setList: (state, payload) => ({
      ...state,
      list: payload
    }),
    setScrollIndex: (state, payload) => ({
      ...state,
      scrollIndex: payload
    }),
  },
  effects: () => ({}),
});

export const { setList, setScrollIndex } = productDetail.actions;
export const selectList = (state) => state.productDetail.list;

export default productDetail.reducer;